
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Alert, AlertTitle } from '@material-ui/lab';



const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      marginTop:'1rem',
      marginBottom:'1rem',
      '& > * + *': {
        marginTop: theme.spacing(2),
      },
    },
  }));

export const CommentShow = (props) => {
    const {commentTitle = 'Admin Comment', commentSummary = 'yup!'} = props || {}
    const classes = useStyles();

  return (
   <div className={classes.root}>
        <Alert icon={false} variant="outlined"  severity="warning">
            <AlertTitle><strong>{commentTitle}</strong></AlertTitle>{commentSummary}
        </Alert>
    </div>
  )
}
